module.exports = __webpack_public_path__ + "static/media/rexroth.37f8a821.gif";